module.exports = __webpack_public_path__ + "assets/img/15_374.d0c6f41a.jpg";